/**
 * The donation form's steps, from Paytrail Donations' DOM events. See
 * lib/analytics-donations.php for the events; donation_complete is pushed
 * from there, by the server.
 */

/**
 * The plugin's detail as the event's donation object.
 *
 * @param {Object} detail The DOM event's detail.
 * @return {Object} The donation.
 */
function donation(detail) {
	return {
		value: detail.amount,
		currency: detail.currency,
		purpose: detail.purpose,
		purpose_id: detail.purposeId,
	};
}

/**
 * donation_begin and donation_payment_info. Listening costs nothing on a
 * page without a donation form: the events never come.
 *
 * @param {Function} push window.diakonPush.
 */
export function initDonationAnalytics(push) {
	document.addEventListener('paytrail-donations:begin', (event) => {
		push({ event: 'donation_begin', donation: donation(event.detail) });
	});

	document.addEventListener('paytrail-donations:payment', (event) => {
		push({
			event: 'donation_payment_info',
			donation: {
				...donation(event.detail),
				payment_type: event.detail.method,
			},
		});
	});
}
